import { initFeatureHighlight, initVideoSwitcher } from "./utils";

initVideoSwitcher();
initFeatureHighlight();
